<template>

  <div class="page">
    
    <div class="top"></div>
    
  <!-- block开始 -->
  <!-- <div class="content-block"> -->

    <div class="main" ref="main">
      
      <div class="bg">
        
        <div class="back" @click="showPopup"></div>
        
        <div :class="['icon', iconClassName]"></div>

        <div class="bgcolor">
          <ul>
            <li v-for="(item, index) in bgColors" :key="item" @click="onBgColor(index)"></li>
          </ul>
        </div>

        <!-- <div class="reset" @click="onReset"></div> -->

        <div class="create" ref="create">
          <canvas-drag 
            :imgArr="imgArr" 
            :bgColor="bgColor"
            ref="canvasDrag"
          >
          </canvas-drag>
        </div>

        <div class="big">
          <div class="btn-switch-left" @click="goPrev"></div>
          <div class="btn-switch-right" @click="goNext"></div>
          <van-swipe ref="swipe" class="swiper" :show-indicators="false">
            <van-swipe-item v-for="item in elementArr" :key="item.id" @click="onClick">
              <div class="img"><img :src="item.img" /></div>
              <div class="text">{{ item.text }}</div>
            </van-swipe-item>
          </van-swipe>
        </div>

        <div class="small"></div>

      </div>

      <!-- <div class="btns">
        <div class="btn back" @click="back"></div>
        <div class="btn create" @click="next"></div>
      </div> -->
      
      <div class="btn-create">
        <div class="btn" @click="next"></div>
      </div>

      <div class="guide-overlay" v-show="guide" @click="hideGuide"></div>
      <div class="guide" v-show="guide" @click="hideGuide"></div>
      
    </div>

    <!-- <van-popup v-model="guide"></van-popup> -->

    <van-popup v-model="show">
      <div class="popup">
        <a href="javascript:;" class="yes" @click="back"></a>
        <a href="javascript:;" class="no" @click="close"></a>
      </div>
    </van-popup>
  
  <!-- </div> -->
  <!-- block结束 -->

  </div>

</template>

<script>
// import Vue from 'vue';
// import { Popup } from 'vant';
// Vue.use(Popup);
import { setStore } from "@/util/store";
import canvasDrag from '@/components/canvas-drag';
import Canvas2Image from '@/util/canvas2Image';
import { Swipe, SwipeItem } from "vant";
export default {
  props: {
    selectId: {
      type:  [Number, String],
      default: 1
    }
  },
  components: {
    canvasDrag,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      guide: true,
      show: false,
      iconClassName: 'icon1',
      bgColors: [
        require("@/images/create/bg/1.png"),
        require("@/images/create/bg/2.png"),
        require("@/images/create/bg/3.png"),
        require("@/images/create/bg/4.png")
      ],
      bgColor: require("@/images/create/bg/1.png"),
      url: '',
      imgArr: [],
      elementImg: '',
      elementArr: [
        {id:1, selectId:1, img:require("../images/create/1/1.png"), text:'想要穿破天际的火箭'},
        {id:2, img:require("../images/create/1/2.png"), text:'一部超现实主义的电影'},
        {id:3, img:require("../images/create/1/3.png"), text:'一双有神的眼睛'},
        {id:4, img:require("../images/create/1/4.png"), text:'最佳电影标签'},
        {id:5, img:require("../images/create/1/5.png"), text:'两朵云的故事'},
        {id:6, img:require("../images/create/1/6.png"), text:'不要靠近警戒线'},
        {id:7, img:require("../images/create/1/7.png"), text:'时刻会爆炸的火焰'},
        {id:8, img:require("../images/create/1/8.png"), text:'一个有故事的胶带'},
        {id:9, img:require("../images/create/1/9.png"), text:'360°环绕全息音响'},

        {id:10, selectId:2, img:require("../images/create/2/1.png"), text:'不屑拿全勤奖的太阳'},
        {id:11, img:require("../images/create/2/2.png"), text:'太阳的光辉'},
        {id:12, img:require("../images/create/2/3.png"), text:'不知是谁弄丢的脚'},
        {id:13, img:require("../images/create/2/4.png"), text:'月亮兄弟-哥哥'},
        {id:14, img:require("../images/create/2/5.png"), text:'月亮兄弟-弟弟'},
        // {id:15, img:require("../images/create/2/6.png"), text:'不要靠近警戒线'},
        {id:16, img:require("../images/create/2/7.png"), text:'用了就会变潮的格子'},
        {id:17, img:require("../images/create/2/8.png"), text:'社畜的对话'},
        {id:18, img:require("../images/create/2/9.png"), text:'朴实无华的星星'},

        {id:19, selectId:3, img:require("../images/create/3/1.png"), text:'一颗大喊大叫的跳跳糖'},
        {id:20, img:require("../images/create/3/2.png"), text:'一朵黑黑的云'},
        {id:21, img:require("../images/create/3/3.png"), text:'大喊大叫的气泡'},
        {id:22, img:require("../images/create/3/4.png"), text:'一颗看戏的星星'},
        {id:23, img:require("../images/create/3/5.png"), text:'一朵无语的小花'},
        // {id:24, img:require("../images/create/3/6.png"), text:'不要靠近警戒线'},
        // {id:25, img:require("../images/create/3/7.png"), text:'用了就会变潮的格子'},
        // {id:26, img:require("../images/create/3/8.png"), text:'一个有故事的胶带'},
        {id:27, img:require("../images/create/3/9.png"), text:'半张黑色“纸”星'},

        {id:28, selectId:4, img:require("../images/create/4/1.png"), text:'在危险边缘试探的香蕉'},
        // {id:29, img:require("../images/create/4/2.png"), text:'不要靠近警戒线'},
        {id:30, img:require("../images/create/4/3.png"), text:'现场留下的神秘信息'},
        {id:31, img:require("../images/create/4/4.png"), text:'不知是谁的脚印'},
        {id:32, img:require("../images/create/4/5.png"), text:'一个艺术品介绍'},
        //？？ {id:33, img:require("../images/create/4/6.png"), text:'一个神奇的黑洞'},
        // {id:34, img:require("../images/create/4/7.png"), text:'用了就会变潮的格子'},
        // {id:35, img:require("../images/create/4/8.png"), text:'一个有故事的胶带'},
        {id:36, img:require("../images/create/4/9.png"), text:'朴实无华的格子'},

        {id:37, selectId:5, img:require("../images/create/5/1.png"), text:'一副消失的蒙娜丽莎'},
        {id:38, img:require("../images/create/5/2.png"), text:'波普几何画框'},
        {id:39, img:require("../images/create/5/3.png"), text:'解构主义眼神'},
        {id:40, img:require("../images/create/5/4.png"), text:'欧阳锋的香肠嘴'},
        {id:41, img:require("../images/create/5/5.png"), text:'蒙娜丽莎的王冠'},
        // {id:42, img:require("../images/create/5/6.png"), text:'不要靠近警戒线'},
        // {id:43, img:require("../images/create/5/7.png"), text:'用了就会变潮的格子'},
        // {id:44, img:require("../images/create/5/8.png"), text:'一个有故事的胶带'},
        {id:45, img:require("../images/create/5/9.png"), text:'朴实无华的链子'},

        {id:46, selectId:6, img:require("../images/create/6/1.png"), text:'一把有毒的蘑菇伞'},
        {id:47, img:require("../images/create/6/2.png"), text:'蘑菇的幻觉秘境'},
        // {id:48, img:require("../images/create/6/3.png"), text:'解构主义眼神'},
        {id:49, img:require("../images/create/6/4.png"), text:'神奇的波点'},
        {id:50, img:require("../images/create/6/5.png"), text:'biu biu biu'},
        // {id:51, img:require("../images/create/6/6.png"), text:'不要靠近警戒线'},
        // {id:52, img:require("../images/create/6/7.png"), text:'用了就会变潮的格子'},
        // {id:53, img:require("../images/create/6/8.png"), text:'一个有故事的胶带'},
        {id:54, img:require("../images/create/6/9.png"), text:'五颜六色的眼睛'},

        {id:55, selectId:7, img:require("../images/create/7/1.png"), text:'奇特香菜怪味面包'},
        // {id:56, img:require("../images/create/7/2.png"), text:'用了就会变潮的格子'},
        //？？ {id:57, img:require("../images/create/7/3.png"), text:'期待香菜的眼神'},
        {id:58, img:require("../images/create/7/4.png"), text:'妈妈给的香菜'},
        {id:59, img:require("../images/create/7/5.png"), text:'香菜家庭'},
        // {id:60, img:require("../images/create/7/6.png"), text:'不要靠近警戒线'},
        // {id:61, img:require("../images/create/7/7.png"), text:'一个神秘语言'},
        // {id:62, img:require("../images/create/7/8.png"), text:'一个有故事的胶带'},
        {id:63, img:require("../images/create/7/9.png"), text:'朴实无华的墨镜'},

        {id:64, img:require("../images/create/8/1.png"), text:'一个闪亮的标题'},
        {id:65, img:require("../images/create/8/2.png"), text:'一个漂浮的球球'},
        {id:66, img:require("../images/create/8/3.png"), text:'一个可回收标志'},
        {id:67, img:require("../images/create/8/4.png"), text:'一个马赛克相框'},
        {id:68, img:require("../images/create/8/5.png"), text:'关于南瓜条纹的故事'},
        {id:69, img:require("../images/create/8/6.png"), text:'360°环绕声波'},
        {id:70, img:require("../images/create/8/7.png"), text:'关于地平线的线'},
        {id:71, img:require("../images/create/8/8.png"), text:'不太乖标签'},
        {id:72, img:require("../images/create/8/9.png"), text:'关于潮流的纸张'},
        {id:73, img:require("../images/create/8/10.png"), text:'请勿靠近银色警戒线'},
        // {id:74, img:require("../images/create/8/11.png"), text:'想要穿破天际的线'}
      ],
      swiper: [
        require("@/images/create/1/1.png"),
        require("@/images/create/1/2.png"),
        require("@/images/create/1/3.png"),
        require("@/images/create/1/4.png"),
        require("@/images/create/1/5.png"),
        require("@/images/create/1/6.png"),
        require("@/images/create/1/7.png"),
        require("@/images/create/1/8.png"),
        require("@/images/create/1/9.png")
      ],
    };
  },
  mounted() {
    // console.log(this.elementArr);
    console.log(this.selectId)
    this.iconClassName = 'icon'+this.selectId
    console.log(this.iconClassName)
    // this.myCanvas = this.$refs.bargraphCanvas;
    // this.ctx = this.myCanvas.getContext('2d');
    // this.loadImg();
    // this.canvasEventsInit();
    this.onLoad();
  },
  methods: {
    // 弹窗
    showGuide() {
      this.guide = true;
    },
    // 弹窗
    hideGuide() {
      this.guide = false;
    },
    // 弹窗
    showPopup() {
      this.show = true;
    },
    // Yes
    back() {
      this.$emit("back");
    },
    close() {
      this.show = false;
    },
    onLoad() {
      var url;
      // 根据selectId推送主元素到画板
      if ( this.elementImg ) {
        url = this.elementImg;
      } else {
        var id = this.selectId
        const index = this.elementArr.findIndex((item) => item.selectId === id);
        var data = this.elementArr[index];
        url = data.img;
        this.elementImg = url
        // 根据selectId在数组中删除子元素
        this.elementArr.splice(index, 1);
        // console.log(this.elementArr)
      }
      this.picReduce(url, imgObj => {this.imgArr.push(imgObj)}, 1)
    },
    // onReset() {
    //   // 清空画布和数组
    //   this.$refs.canvasDrag.reset();
    //   // 重载主元素
    //   this.onLoad();
    // },
    onBgColor(index) {
      console.log(index)
      this.bgColor = this.bgColors[index]
    },
    onClick(e) {
      console.log(e)
      var url = e.target.currentSrc
      this.picReduce(url, imgObj => {
        this.imgArr.push(imgObj)
      })
    },
    // changeImage (e) {
    //   const fileObj = new FileReader()
    //   fileObj.readAsDataURL(e.target.files[0])
    //   fileObj.onload = () => {
    //     this.picReduce(fileObj.result, imgObj => {
    //       this.imgArr.push(imgObj)
    //     })
    //   }
    // },
    picReduce (picObj, callback, flag=0) {
      console.log(flag);
      const img = new Image()
      img.src = picObj
      img.onload = () => {
        const w = img.width
        const h = img.height
        const scale = this.getScale(w, h)
        const maxW = w / scale
        const maxH = h / scale
        const imgObj = {
          url: img,
          width: maxW,
          height: maxH,
          flag: flag
        }
        callback(imgObj)
      }
    },
    getScale (width, height) {
      if (width >= height) {
        if (height <= 120) {
          return 1
        } else {
          return height / 120
        }
      } else if (height > width) {
        if (width <= 120) {
          return 1
        } else return width / 120
      }
    },
    goPrev() {
      this.$refs.swipe.prev();
    },
    goNext() {
      this.$refs.swipe.next();
    },
    // 下一步
    next() {
      this.$refs.canvasDrag.clear()
      var canvas = document.getElementById('myCanvas')
      var img = Canvas2Image.convertToPNG(canvas, canvas.width*4, canvas.height*4)
      var resultImg = img.getAttribute('src')
      var data = {
        resultImg: resultImg,
        bgColor: this.bgColor
      }
      // 存入缓存
      setStore({name: 'resultImg', content: data.resultImg});
      setStore({name: 'bgColor', content: data.bgColor});
      // console.log(data)
      // Canvas2Image.saveAsPNG(c, 200, 200)
      // Canvas2Image()
      this.$emit("next", data);
    }
  },
};
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  background: url("../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
  // .content-block {
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   width: 100%;
  //   height: 1200px;
  //   top: 50%;
  //   margin-top: -600px;
  // }
}
.van-popup {
  background-color: transparent;
  .popup {
    width: 464px;
    height: 207px;
    background: transparent url("../images/create/layer-stop.png") center center no-repeat;
    background-size: 100%;
    position: relative;
    a {
      // border: 1px solid red;
      width: 80px;
      height: 50px;
      display: inline-block;
      position: absolute;
      bottom: 50px;
    }
    .yes {
      left: 140px;
    }
    .no {
      right: 140px;
    }
  }
}
.top {
  z-index: 2;
  // position: absolute;
  // bottom: 80%;
  width: 751px;
  height: 209px;
  background: url("../images/title.png") no-repeat;
  background-size: 100%;
}
// .content-block {
//   position: absolute;
//   left: 0;
//   right: 0;
//   width: 100%;
//   height: 1200px;
//   top: 50%;
//   margin-top: -600px;
// }
.main {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 1000px;
  top: 50%;
  margin-top: -500px;
  .guide-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
  }
  .guide {
    position: absolute;
    z-index: 12;
    top: 160px;
    left: 80px;
    // right: 83px;
    width: 608px;
    height: 1006px;
    background: url("../images/create/layer-guide.png") no-repeat;
    background-size: 100%;
  }
  // z-index: 3;
  // position: absolute;
  // width: 100%;
  // left: 0;
  // right: 0;
  // top: 50%;
  // margin-top: 200px;
  // box-sizing: border-box;
  // margin: 0 auto;
  .bg {
    width: 626px;
    height: 905px;
    background: url("../images/bg/bg-create.png") no-repeat;
    background-size: 100%;
    margin: 0 auto 0;
    overflow: hidden;
    .back {
      position: absolute;
      z-index: 4;
      top: -20px;
      left: 60px;
      width: 221px;
      height: 94px;
      background: url("../images/create/btn-select.png") no-repeat;
      background-size: 100%;
    }
    .icon {
      position: absolute;
      z-index: 4;
    }
    .icon1 { top: -50px; right: 40px; width: 221px; height: 214px; background: url("../images/create/icon/1.png") no-repeat; background-size: 100%; }
    .icon2 { top: -50px; right: 40px; width: 212px; height: 141px; background: url("../images/create/icon/2.png") no-repeat; background-size: 100%; }
    .icon3 { top: -50px; right: 40px; width: 203px; height: 169px; background: url("../images/create/icon/3.png") no-repeat; background-size: 100%; }
    .icon4 { top: -30px; right: 65px; width: 127px; height: 181px; background: url("../images/create/icon/4.png") no-repeat; background-size: 100%; }
    .icon5 { top: -40px; right: 50px; width: 230px; height: 114px; background: url("../images/create/icon/5.png") no-repeat; background-size: 100%; }
    .icon6 { top: -50px; right: 40px; width: 169px; height: 134px; background: url("../images/create/icon/6.png") no-repeat; background-size: 100%; }
    .icon7 { top: -30px; right: 45px; width: 188px; height: 124px; background: url("../images/create/icon/7.png") no-repeat; background-size: 100%; }
    .bgcolor {
      position: absolute;
      z-index: 4;
      top: 540px;
      left: 83px;
      width: 291px;
      height: 67px;
      background: url("../images/create/btn-bgcolor.png") no-repeat;
      background-size: 100%;
      ul {
        display: flex;
        margin: 5px 0 0 60px;
        li {
          // border: 1px solid red;
          // background-color: rgba(255, 255, 255 .5);
          width: 55px;
          height: 52px;
        }
      }
    }
    .reset {
      position: absolute;
      z-index: 4;
      top: 540px;
      right: 83px;
      width: 71px;
      height: 67px;
      background: url("../images/btn-reset.png") no-repeat;
      background-size: 100%;
    }
    .create {
      // border: 1px solid red;
      position: absolute;
      z-index: 3;
      top: 19px;
      left: 106px;
      // right: 0;
      // margin: 19px auto 0;
      width: 535px;
      height: 536px;
      border-radius: 20px;
      box-sizing: border-box;
    }
    .big {
      // border: 1px solid red;
      position: absolute;
      top: 632px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 460px;
      height: 260px;
      overflow: hidden;
      .btn-switch-left {
        position: absolute;
        z-index: 2;
        top: 80px;
        left: 10px;
        // left: 155px;
        // top: 712px;
        width: 40px;
        height: 40px;
        // border: 1px solid red;
      }
      .btn-switch-right {
        position: absolute;
        z-index: 2;
        top: 80px;
        right: 10px;
        // right: 155px;
        // top: 712px;
        width: 40px;
        height: 40px;
        // border: 1px solid red;
      }
      .swiper {
        position: absolute;
        top: 22px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 340px;
        height: 210px;
        text-align: center;
        .img {
          width: 100%;
          height: 150px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          box-sizing: border-box;
          // height: 200px;
          // border: 3px solid green; 
          img {
            // width: 100%;
            max-width: 100%;
            max-height: 100%;
          }
        }
        .text {
          // position: absolute;
          // border: 1px solid red;
          margin-top: 15px;
          width: 100%;
          height: 32px;
          line-height: 32px;
          font-family: 'zpix';
          font-size: 20px;
          color: #000;
        }
        
      }
      // .swiper-slide {
      //   width: 390px;
      //   height: 336px;
      //   // float: left;
      //   img {
      //     width: 100%;
      //     height: 100%;
      //   }
      // }
    }
  }
  .btn-create {
    width: 648px;
    height: 91px;
    background: url("../images/btn-bg.png") no-repeat center center;
    background-size: 648px 91px;
    text-align: center;
    margin: 0 auto;
    .btn {
      width: 299px;
      height: 91px;
      margin: 0 auto;
      background: url("../images/btn-save.png") no-repeat;
      background-size: 100%;
    }
  }
}
</style>
